<template>
  <div class="procurement-plan">
    <div class="container">
      <tab :tabs-value="activeIndex" :tab-pane-data="tabArr" style="margin-bottom: 20px" @tabClick="handleTab" />
      <ESearch
        :list-type-info="listTypeInfo"
        style="margin-bottom: 20px"
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></ESearch>
    </div>
    <div class="container">
      <ETableList
        :index-show="true"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :reserve-selection="false"
        class="margin-b20"
      >
        <template #title="{ scope: { row } }">
          <eui-btn type="text" size="12" class="title" :title="row.title" @click="findAnnouncement(row)">
            {{ row.title }}
          </eui-btn>
        </template>
        <template #operate="{ scope: { row } }">
          <eui-btn
            v-if="activeIndex === '0'"
            type="link"
            size="20"
            class="blue-box"
            @click="handleClick(row, '/auditManagement/announcementAudit')"
          >
            审批
          </eui-btn>
          <eui-btn
            v-else
            type="link"
            size="20"
            class="blue-box"
            @click="handleClick(row, '/auditManagement/announcementDetail')"
          >
            查看详情
          </eui-btn>
        </template>
      </ETableList>
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="queryData.pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <PreviewDialog :preview-visible.sync="previewVisible" :preview-data.sync="previewData"></PreviewDialog>
  </div>
</template>
<script>
import ESearch from '@/modules/projectA/components/common/e-search.vue';
import ETableList from '@/modules/projectA/components/common/e-table-list';
import Tab from '@/modules/projectA/components/common/e-tabs.vue';
import Api from '@/modules/projectA/api/auditManagement/index';
import api from '@/modules/projectA/api/announcement';
import PreviewDialog from '@/modules/projectA/pages/announcementManage/announcement/components/PreviewDialog.vue';

export default {
  name: 'ProcurementPlan',
  components: { ESearch, ETableList, Tab, PreviewDialog },
  data() {
    return {
      activeIndex: '0',
      tabArr: [
        {
          label: '待审批',
          id: '0',
        },
        {
          label: '已审批',
          id: '1',
        },
      ],
      listTypeInfo: {
        statusList: [
          { name: '全部', id: null },
          { name: '新建', id: 1 },
          { name: '待审核', id: 2 },
          { name: '审核通过', id: 3 },
          { name: '驳回', id: 4 },
        ],
      },
      loading: false,
      filterInfo: {
        data: {
          title: null,
          createName: null,
          createTime: null,
          endTime: '',
          startTime: '',
          pageNum: 1,
          pageSize: 10,
        },
        fieldList: [
          { label: '标题', type: 'input', value: 'title' },
          { label: '创建人', type: 'input', value: 'createName' },
          {
            label: '提交时间',
            type: 'date',
            value: 'createTime',
            dateType: 'daterange',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            defaultTime: ['00:00:00', '23:59:59'],
          },
        ],
      },
      tableData: [],
      tableLabelAll: [
        { label: '公告标题', param: 'title', align: 'center', slot: 'title' },
        { label: '创建人', param: 'createName', align: 'center' },
        { label: '创建时间', param: 'createTime', align: 'center' },
        { label: '提交时间', param: 'submitTime', align: 'center' },
        { label: '审核时间', param: 'auditTime', align: 'center', hidden: '0' },
        {
          label: '发布状态',
          param: 'status',
          align: 'center',
          render: (row) => {
            if (row.status === 0) {
              return '未发布';
            }
            if (row.status === 1) {
              return '已发布';
            }
            return '';
          },
        },
        { label: '操作', param: '', align: 'center', slot: 'operate', hidden: '1' },
      ],
      queryData: {
        title: null,
        createName: null,
        createTime: null,
        endTime: '',
        startTime: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      uniqueId: `${this.$route.query.t}`,
      previewVisible: false,
      previewData: {},
    };
  },
  computed: {
    tableLabel() {
      return this.tableLabelAll.filter((item) => {
        if (item.hidden) {
          return item.hidden !== this.activeIndex;
        }
        return true;
      });
    },
  },
  mounted() {
    console.log('mounted');
    this.queryAuditPage();
  },
  activated() {
    console.log('activated');
    const time = `${this.$route.query.t}`;
    if (time && time !== this.uniqueId) {
      this.uniqueId = time;
      this.queryData.pageNum = 1;
      this.queryData.pageSize = 10;

      this.queryAuditPage();
    }
  },
  methods: {
    async findAnnouncement(row, isPreview = true) {
      // 查看咨询公告预览
      const { code, data } = await api.queryAnnouncement({ id: row.businessId });
      if (code === '200') {
        if (isPreview) {
          this.previewVisible = true;
        }
        this.previewData = data;
      }
    },
    handleClick(row, url) {
      const { businessId } = row;
      this.$router.push({
        path: url,
        query: {
          businessId,
          t: Date.now(),
        },
      });
    },
    handleTab(row) {
      this.queryData = {
        title: null,
        createName: null,
        createTime: null,
        endTime: '',
        startTime: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };

      this.activeIndex = row.name;
      if (this.activeIndex === '1') {
        this.queryReviewedPage();
      } else {
        this.queryAuditPage();
      }
    },
    async queryReviewedPage() {
      const res = await Api.queryReviewedPage(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
    handleReset() {
      this.queryData = {
        title: null,
        createName: null,
        createTime: null,
        endTime: '',
        startTime: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      if (this.activeIndex === '1') {
        this.queryReviewedPage();
      } else {
        this.queryAuditPage();
      }
    },
    handleFilter(val) {
      this.queryData.title = val.title ? val.title : null;
      this.queryData.createName = val.createName ? val.createName : null;
      this.queryData.startTime = val.createTime && val.createTime.length > 0 ? val.createTime[0] : null;
      this.queryData.endTime = val.createTime && val.createTime.length > 0 ? val.createTime[1] : null;
      if (this.activeIndex === '1') {
        this.queryReviewedPage();
      } else {
        this.queryAuditPage();
      }
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      if (this.activeIndex === '1') {
        this.queryReviewedPage();
      } else {
        this.queryAuditPage();
      }
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      if (this.activeIndex === '1') {
        this.queryReviewedPage();
      } else {
        this.queryAuditPage();
      }
    },
    async queryAuditPage() {
      const res = await Api.queryAuditPage(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.procurement-plan {
  // background: #fff;
}
.blue-box {
  color: #2f80ed;
  cursor: pointer;
  &:hover {
    border-bottom: 1px solid #2f80ed;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>
